import React from 'react'

import { Box, Button, ButtonColorVariant, FontWeight, Text } from '@gousto-internal/citrus-react'
import { browserHistory } from 'react-router'

import { client } from 'config/routes'

import { ThankYou } from './ThankYou'

import css from './OrderFeedback.css'

type OrderFeedBackConfirmationProps = {
  score: number
}

export const OrderFeedBackConfirmation = ({ score }: OrderFeedBackConfirmationProps) => {
  const isSentimentPositive = score >= 3

  const handleReportIssue = () => {
    browserHistory.push(`${client.getHelp.index}/${client.getHelp.contact}`)
  }

  return (
    <>
      <Text fontWeight={FontWeight.Bold} size={5}>
        Thank you for sharing!
      </Text>
      <Box paddingV={2}>
        <ThankYou className={isSentimentPositive ? css.shake : undefined} />
      </Box>
      {!isSentimentPositive && (
        <Button
          colorVariant={ButtonColorVariant.Secondary}
          onClick={handleReportIssue}
          width="100%"
        >
          Report an issue
        </Button>
      )}
    </>
  )
}
